import { create } from 'jss';
import { BrowserRouter } from 'react-router-dom';
import SmoothScroll from 'smoothscroll-polyfill';
import { ApolloProvider } from '@apollo/client';
import {
  ThemeProvider,
  StylesProvider,
  jssPreset,
} from '@material-ui/core/styles';
import { createTheme } from '@material-ui/core/styles';
import getApolloClient from '../lib/getApolloClient';
import muiTheme from '../lib/muiTheme';
import App from './App';
import '../styles/greenbeard.scss';
import '../styles/app.css';

SmoothScroll.polyfill();

const jss = create({
  ...jssPreset(),
  insertionPoint: document.getElementById('jss-insertion-point'),
});

export default function Root() {
  return (
    <ApolloProvider client={getApolloClient()}>
      <StylesProvider jss={jss}>
        <ThemeProvider theme={createTheme(muiTheme)}>
          <BrowserRouter basename="/market">
            <App />
          </BrowserRouter>
        </ThemeProvider>
      </StylesProvider>
    </ApolloProvider>
  );
}
